export default {
    GET_COURSE_REQUEST: 'COURSE_REORDER_CURRICULUM_GET_COURSE_REQUEST',
    GET_COURSE_SUCCESS: 'COURSE_REORDER_CURRICULUM_GET_COURSE_SUCCESS',
    REORDER_COURSE_ITEMS_REQUEST: 'COURSE_REORDER_CURRICULUM_REORDER_COURSE_ITEMS_REQUEST',
    REORDER_COURSE_ITEMS_SUCCESS: 'COURSE_REORDER_CURRICULUM_REORDER_COURSE_ITEMS_SUCCESS',
    DISPOSE: 'COURSE_REORDER_CURRICULUM_DISPOSE_STORE',
};
